import { render, staticRenderFns } from "./EditPlanItem.vue?vue&type=template&id=1f106e54&scoped=true&"
import script from "./EditPlanItem.vue?vue&type=script&lang=js&"
export * from "./EditPlanItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f106e54",
  null
  
)

export default component.exports